<template>
  <v-dialog v-model="dialog" persistent max-width="950px" ref="winAssociation">
    <v-card>
      <v-card-title>
        <div>
          <h1>
            Importer
            <span class="bis">les images</span>
          </h1>
        </div>
      </v-card-title>
      <v-card-text grid-list-xl>
        <v-container fluid pa-0 grid-list-xl formlittle ref="mycontainer">
          <div class="overline">
            Envoyer des images nommées très exactement de la façon suivante (respecter les minuscules dans l'extension du fichier) :
            <ul>
              <li>référence.jpg ou</li>
              <li>référence-pack.jpg ou</li>
              <li>référence-display.jpg</li>
            </ul>Les références que vous envoyez doivent déjà être importées dans la matrice.
            Toutes les images ne respectant pas ce format ne seront pas importées.
            <br />
            <br />
          </div>
          <div
            class="frameDropImage"
            ref="frameDropImage"
            @drop.prevent="dropimages"
            @dragover.prevent="dragoverimages"
            @dragleave.prevent="dragleaveimages"
          >
            <h2>Déposer ici un ou des fichiers de votre bureau</h2>
          </div>

          <v-form ref="form" v-model="valid">
            <div>Ou bien, joindre des fichiers ci-dessous, en les choisissant sur votre disque dur</div>
            <m-form-file label="Joindre les images" ref="mformfileImages" @inputfile="inputImages" />
          </v-form>
          <div v-for="(image,indexImage) in imagesThumbnails" :key="indexImage" class="item_image">
            <v-img
              v-if="image.binary"
              :src="image.binary"
              height="75px"
              width="75px"
              :ref="`littleimg${indexImage}`"
            />
          </div>
          <div style="clear:both;"></div>
          <v-progress-linear :value="progressValue"></v-progress-linear>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary2" text @click="cancelWin()" :disabled="disabledBtn">Annuler</v-btn>
        <v-btn color="primary2" depressed @click="saveWin()" :disabled="disabledBtn">Importer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "matricewinimages",
  props: ["filters"],
  data() {
    return {
      disabledBtn: false,
      progressValue: 0,
      dialog: false,
      valid: true,
      images: [],
      imagesThumbnails: []
    };
  },
  mounted() {
    window.addEventListener("resize", this.setContainerStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.setContainerStyle);
  },
  computed: {},
  watch: {},
  components: {},
  methods: {
    dragleaveimages(e) {
      this.$refs.frameDropImage.style.backgroundColor = "white";
    },
    dragoverimages(e) {
      this.$refs.frameDropImage.style.backgroundColor = "green";
    },
    dropimages(e) {
      this.$refs.frameDropImage.style.backgroundColor = "white";
      let droppedFiles = e.dataTransfer.files;
      // console.log("droppedFiles", droppedFiles);
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.images.push(f);
        this.createThumbnail(f);
      });
      // this.$emit("inputfile", this.files, "images");
    },
    createThumbnail(f) {
      if (f.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        var reader = new FileReader();
        var me = this;
        reader.onload = (function(theFile) {
          return function(e) {
            me.imagesThumbnails.push({
              file: f,
              binary: e.target.result
            });
          };
        })(f);
        reader.readAsDataURL(f);
      }
    },
    open() {
      this.images = [];
      this.dialog = true;
      if (this.$refs.mformfileImages) this.$refs.mformfileImages.reset();
      this.imagesThumbnails = [];
      this.progressValue = 0;
      this.disabledBtn = false;
    },
    inputImages(images) {
      // console.log("files", files);
      if (images.length) this.images = this.$_.concat(this.images, images);
      this.$refs.mformfileImages.reset();
      this.imagesThumbnails = [];
      for (let iImages = 0; iImages < this.images.length; iImages++) {
        const image = this.images[iImages];
        this.createThumbnail(image);
      }
    },
    cancelWin() {
      this.dialog = false;
    },
    async saveWin() {
      this.disabledBtn = true;
      this.progressValue = 0;
      for (let iImage = 0; iImage < this.images.length; iImage++) {
        const image = this.images[iImage];
        let formData = new FormData();
        formData.append("image", image);
        this.progressValue = (iImage * 100) / this.images.length;
        await this.$axios.post(
          this.$config.server_url + "/api/1.0/matrice/image",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }
      this.dialog = false;
      this.$emit("imported");
    }
  }
};
</script>

<style lang="scss">
.frameDropImage {
  background-color: white;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border: 1px solid black;
  border-radius: 10px;
  height: 200px;
  width: 100%;
  justify-content: center;
}
.btn-norme-matrice {
  width: 100%;
}
.item_image {
  padding: 2px;
  cursor: move;
  float: left;
}
</style>